<div
  class="self-end max-w-[85%] px-3.5 py-2.5 rounded-xl rounded-br b2 leading-normal break-words text-gray-000 bg-blue-600">
  <span class="whitespace-pre-wrap">{{ content() }}</span>
</div>
